const LoginFooterSVG = ({ viewBox = '0 0 1440 320' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className="position-absolute bottom-0" viewBox={viewBox}>
    <path
      fill="#4987be"
      fillOpacity="1"
      d="M0,288L48,277.3C96,267,192,245,288,229.3C384,213,480,203,576,197.3C672,192,768,192,864,202.7C960,213,1056,235,1152,234.7C1248,235,1344,213,1392,202.7L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
    />
  </svg>
);
export default LoginFooterSVG;
